// extracted by mini-css-extract-plugin
export var deliveryRow = "_se-a";
export var fixedHeight = "_se-4";
export var freightLogo = "_se-9";
export var fullWidth = "_se-3";
export var priceColumn = "_se-5";
export var radioSelected = "_se-7";
export var radioUnselected = "_se-6";
export var selectedOption = "_se-2";
export var selectedOptionContainer = "_se-1";
export var selection = "_se-0";
export var tallSkeletonText = "_se-8";